import { Badge, theme } from 'antd';
import * as React from 'react';
import { useFormCoordinatorContext } from '../FormCoordinatorContext';

export interface IFormCoordinatorBadgeProps {
  formId: string;
}

/**
 * Mostra un Badge giallo se il form è dirty
 */
export function FormCoordinatorBadge(props: IFormCoordinatorBadgeProps) {
  const { formId: id } = props;
  const { token } = theme.useToken();
  const coordinator = useFormCoordinatorContext();
  const { isDirty, isValid } = coordinator?.forms[id] ?? {};

  return isDirty ? (
    <Badge color={isValid ? token.colorWarning : token['red-6']} />
  ) : null;
}
